export function formatPrice(value, locale, currency) {
  return new Intl.NumberFormat(locale || "en-GB", {
    style: "currency",
    currency,
  }).format(value);
}
